import { render } from "./list.vue?vue&type=template&id=082ff73a"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
script.render = render

export default script